module.exports = __webpack_public_path__ + "10_hair_gold.c9c27895.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/10_hair_gold.png
// module id = 7WpJ
// module chunks = 0